import {portIncidentAPI} from 'features/port/api/portIncidentAPI';
import {
    getPortIncidentDateFormat,
    getPortIncidentDurationSeconds,
    hasPortRecoveryResults,
    isPortIncidentOpen,
} from 'features/port/lib/portIncidentHelper';
import {isTranslate} from 'shared/lib/lang';

import IPortIncident from './PortIncident/IPortIncident';

export interface IUsePortIncident {
    incident: IPortIncident | undefined,
    isLoading: boolean,
    isIncidentOpen: boolean,
    durationSeconds: number,
    hasRecovery: boolean,
    dateFormat: string,
}

export const usePortIncident = (uuid: string, isOpen: boolean): IUsePortIncident => {
    const {data: incident, isLoading} = portIncidentAPI.useGetPortIncidentQuery(uuid, {skip: !isOpen});

    return {
        incident,
        isLoading,
        isIncidentOpen: incident ? isPortIncidentOpen(incident) : false,
        durationSeconds: incident ? getPortIncidentDurationSeconds(incident) : 0,
        hasRecovery: incident ? hasPortRecoveryResults(incident) : false,
        dateFormat: getPortIncidentDateFormat(isTranslate()),
    };
};

export default usePortIncident;
